Ext.define('SA.CompositeObserver', {
    statics: {
        create(handler) {
            return new SA.CompositeObserver(handler);
        }
    },

    constructor(handler) {
        this.handler = handler;
        this.removers = [];
    },

    addDomEvent(target, event) {
        target.addEventListener(event, this.handler);
        this.removers.push(() => target.removeEventListener(event, this.handler));
        return this;
    },

    addExtEvent(target, event) {
        target.on(event, this.handler);
        this.removers.push(() => target.un(event, this.handler));
        return this;
    },

    destroy() {
        this.removers.forEach(remover => remover());
    }
});